module.exports = __webpack_public_path__ + "components/country-flag/static/gy-6ea5064d18208e7a6674e1237cb5b99b.svg";